import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const META = {
    info: { glyph: 'ℹ', color: 'var(--secondary)', label: 'Information' },
    success: { glyph: '✓', color: 'var(--success)', label: 'Success' },
    // Text-safe amber (≥ 4.5:1); the bright --warning mark is for fills and rules only (V98-3 review U12).
    warning: { glyph: '⚠', color: 'var(--band-amber)', label: 'Warning' },
    error: { glyph: '✕', color: 'var(--critical)', label: 'Error' },
};
export function Alert({ variant = 'info', title, children, className, id, onDismiss, live = true, focusTitle, part }) {
    const m = META[variant];
    const hasLiveRole = live && !focusTitle;
    return (_jsxs("div", { id: id, className: className, "data-alert": true, "data-variant": variant, "data-part": part, role: hasLiveRole ? (variant === 'error' || variant === 'warning' ? 'alert' : 'status') : undefined, style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 'var(--space-3)',
            border: `1px solid ${m.color}`,
            borderRadius: 'var(--radius-input)',
            padding: 'var(--space-3) var(--space-4)',
            background: 'var(--surface)',
            color: 'var(--text)',
            fontFamily: 'var(--font-ui)',
            fontSize: 'var(--font-size-2xs)',
        }, children: [_jsx("span", { "aria-hidden": "true", "data-part": "glyph", style: { color: m.color, fontSize: 'var(--font-size-md)', lineHeight: 1 }, children: m.glyph }), focusTitle && title ? null : _jsx("span", { className: "sr-only", children: `${m.label}: ` }), _jsxs("div", { style: { flex: 1, minWidth: 0 }, children: [title && focusTitle ? (_jsxs("p", { id: focusTitle.id, tabIndex: -1, "aria-describedby": focusTitle.describedBy, "data-part": "alert-title", style: { fontWeight: 600, color: 'var(--text)', margin: '0 0 2px', outline: 'none' }, children: [_jsx("span", { className: "sr-only", children: `${m.label}: ` }), title] })) : title ? (_jsx("div", { style: { fontWeight: 600, color: 'var(--text)', marginBottom: '2px' }, children: title })) : null, _jsx("div", { children: children })] }), onDismiss ? (_jsx("button", { type: "button", onClick: onDismiss, "aria-label": "Dismiss", style: {
                    background: 'transparent',
                    border: 'none',
                    color: 'var(--text-dim)',
                    cursor: 'pointer',
                    fontSize: 'var(--font-size-md)',
                    minHeight: 'var(--min-touch-target)',
                    minWidth: 'var(--min-touch-target)',
                }, children: "\u00D7" })) : null] }));
}
//# sourceMappingURL=Alert.js.map